<template>
  <div class="wrapper">
    <h1>
      <LogoLink />
    </h1>

    <Counter
      class="counter"
      :class="{ 'counter--visible': currentPage > 1 }"
      :index="currentPage - 2"
    />

    <button
      v-if="!$store.state.isMobileMenuOpen"
      class="button gsap-mobile-button"
      @click="$store.commit('toggleMobileMenu')"
    >
      <span class="dot" />
      <span class="dot" />
      <span class="dot" />
    </button>

    <MobileNav @click="id => $emit('click', id)" />
  </div>
</template>

<script>
import MobileNav from './MobileNav'
import Counter from './SectionCounter'

export default {
  components: {
    MobileNav,
    Counter
  },
  props: {
    currentPage: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  @include hide-up(lg);
  position: fixed;
  top: 20px;
  left: 0;
  width: 100%;
  z-index: z(moble-fixed-top);

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 45px;

  @include media-down(md) {
    padding: 0 20px;
  }
}

.counter {
  transition: unset;
  opacity: 0;

  &--visible {
    opacity: 1;
    transition: opacity 0.2s;
  }
}

.button {
  @include reset-button;
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 55px;
  padding: 20px 0;

  @include media-down(md) {
    width: 28px;
    padding: 10px 0;
  }
}

.dot {
  width: 14px;
  height: 14px;
  background: $text-color;
  border-radius: 50%;

  @include media-down(md) {
    width: 7px;
    height: 7px;
  }
}
</style>
